import { useState } from 'react';
import { 
  Typography, 
  Box, 
  Paper, 
  Tabs, 
  Tab, 
  Divider
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

// Tab panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`account-tabpanel-${index}`}
      aria-labelledby={`account-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function AccountPage() {
  const { user } = useAuth();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Account Settings
      </Typography>
      
      <Box my={3}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <Box p={2} display="flex" alignItems="center">
            {user?.picture && (
              <Box mr={2}>
                <img 
                  src={user.picture}
                  alt={user.name}
                  style={{ 
                    width: 60, 
                    height: 60, 
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
              </Box>
            )}
            <Box>
              <Typography variant="h6">{user?.name}</Typography>
              <Typography variant="body1" color="textSecondary">
                {user?.email}
              </Typography>
            </Box>
          </Box>
          
          <Divider />
          
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="account settings tabs"
            >
              <Tab label="Profile" id="account-tab-0" aria-controls="account-tabpanel-0" />
              <Tab label="Preferences" id="account-tab-1" aria-controls="account-tabpanel-1" />
            </Tabs>
          </Box>
          
          <TabPanel value={tabValue} index={0}>
            <Typography variant="body1">
              Your profile information is managed by Google. You can update your profile
              information in your Google Account settings.
            </Typography>
          </TabPanel>
          
          <TabPanel value={tabValue} index={1}>
            <Typography variant="body1">
              Preferences will be added in a future update.
            </Typography>
          </TabPanel>
        </Paper>
      </Box>
    </Box>
  );
}